module.exports = __webpack_public_path__ + "static/img/operateDay.ee11e37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/operateDay.png
// module id = mnBF
// module chunks = 1